import React from 'react';
import DualListBox from 'react-dual-listbox';
import PropTypes from 'prop-types';
import getLabel from '../../translations/messages';
import {classNames} from '../../functions/classNames';
import './InputDualList.css';
import 'react-dual-listbox/lib/react-dual-listbox.css';

const handleSelectedChange = (name, selected, delegate) => (
    delegate({
        target: {
            name: name,
            value: selected,
        },
    })
);

const InputDualList = ({label, options, name, value, handleChange, vertical, ...other}, context) => {
    return (
        <div className={classNames('InputDualList', vertical ? 'vertical' : '')} name={name}>
            <div className="inputLabel">{getLabel(context.locale, label)}</div>
            <DualListBox
                options={options}
                selected={value}
                onChange={(selected) => handleSelectedChange(name, selected, handleChange)}
                filterCallback={(option, filterInput) => {
                    if (filterInput === '') {
                        return true;
                    }

                    return (new RegExp(escapeRegExp(filterInput), 'i')).test(option.label);
                }}
                {...other}
            />
        </div>
    );
};

function escapeRegExp(input) {
    input = input.replace('(', '\\(');
    input = input.replace(')', '\\)');
    return input;
}

InputDualList.contextTypes = {
    locale: PropTypes.string,
};

export default InputDualList;



// WEBPACK FOOTER //
// ./src/main/components/input/InputDualList.js